<mat-toolbar>
    <button id="btn-menu" mat-icon-button (click)="sidenav.toggle()">
    <span class="material-icons"> menu </span>
  </button>

    <div id="titleName">
        <h2>Mi cuenta</h2>
        <p>¡Hola! {{firebaseAuthService.publicUser.displayName}}</p>
    </div>
</mat-toolbar>

<mat-drawer-container class="example-container" [hasBackdrop]="diviceXs || diviceSm">

    <mat-drawer [mode]="!diviceXs && !diviceSm ? 'side' : 'over'" [opened]="!diviceXs && !diviceSm" #sidenav>
        <app-slider-menu></app-slider-menu>
    </mat-drawer>

    <mat-drawer-content>

        <div id="purchasesDetails">

            <h4 id="dateOrder">{{orderDetails.date.seconds *1000| date: 'dd-MM-yyyy'}}</h4>
            <h1>Compra #{{orderDetails.id | shortOrderCode}}</h1>


            <section fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center">

                <div id="listProducts" fxFlex="55">
                    <h2>Compraste</h2>
                    <ng-container *ngFor="let product of orderDetails.orderDetail">
                        <mat-card fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="space-around center">
                            <div id="img" fxFlex="15" fxFlex.xs="45">
                                <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}" [alt]="product.name">
                                <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg " [alt]="product.name">
                            </div>

                            <div class="contentOne" fxFlex="40" fxFlex.xs="45" (click)="goToProductView(product.id)">
                                <h5>{{product.brand}}</h5>
                                <h3>{{product.name}}</h3>
                                <h4>{{product.reference}}</h4>
                            </div>

                            <div class="contentTwo" fxLayout.xs="row wrap" fxFlex="30" fxFlex.xs="100" fxLayoutAlign.xs="space-around center">
                                <div id="price">
                                    <h3>Precio</h3>
                                    <p>{{product.price | currency:'COP '}}</p>
                                    <p id="gessiRevenue">Acumula: {{product.pointsRevenue}} Gessis</p>
                                </div>

                                <div id="gessiPoints">
                                    <h3>Gessis</h3>
                                    <p>{{product.points}}</p>
                                </div>
                            </div>
                        </mat-card>

                    </ng-container>
                </div>


                <div id="otherInfo" fxFlex="37">

                    <div id="paidMethod">
                        <h3>Información de pago</h3>

                        <ng-container *ngIf="true else paidWithPoints">
                            <!-- <ng-container *ngIf="!orderDetails.paidWithPoints else paidWithPoints"> -->

                            <div id="contentPaidWithMoney">
                                <h4 fxLayout="row" fxLayoutAlign="start center">
                                    <span class="material-icons-outlined">paid</span>
                                    <span> Pago con dinero</span>
                                </h4>

                                <p><strong>Total {{orderDetails.orderDetail.length >= 2 ? 'productos' : 'producto'}}:</strong> {{orderDetails.total | currency:'COP '}}</p>
                                <p><strong>Medio de pago:</strong> {{orderDetails.paymentMethod}}</p>
                                <p id="accumulatedPoints"><strong>Puntos acumulados:</strong> {{generatedPoints}} Gessis
                                </p>
                            </div>

                        </ng-container>

                        <ng-template #paidWithPoints>

                            <div id="contentPaidWithPoints">

                                <h3 fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="center center">
                                    <span id="ic-pointsGessi"></span>
                                    <span>Pago con puntos</span>
                                </h3>
                                <!-- <p><strong>Total:</strong> {{orderDetails.totalPoints}} Gessis</p> -->
                                <p><strong>Total:</strong> X Gessis</p>

                            </div>

                        </ng-template>
                    </div>

                    <div id="addressInfo">
                        <h3>Información de envió</h3>

                        <article>

                            <p>{{orderDetails.addres}}, {{orderDetails.addresExtraInformation}}
                            </p>

                            <p><strong>{{orderDetails.neighborhood}}, {{orderDetails.cityName}} -
                  {{orderDetails.departamento}}</strong></p>

                        </article>
                    </div>

                </div>

            </section>

        </div>
    </mat-drawer-content>
</mat-drawer-container>